export class ListSubnetsResponseV2SubnetsInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpc",
            "baseName": "vpc",
            "type": "string",
            "format": ""
        },
        {
            "name": "availabilityZone",
            "baseName": "availabilityZone",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "cidrBlock",
            "baseName": "cidrBlock",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSubnetsResponseV2SubnetsInner.attributeTypeMap;
    }
    constructor() {
    }
}
